import {useCallback} from "react";
import {useFlags} from "launchdarkly-react-client-sdk";
import {FeatureFlaggedItem} from "./FeatureFlaggedItem";

export type FeatureFlaggedItemPredicate<T extends FeatureFlaggedItem> = (
  item: T
) => boolean;

/**
 * The {@link useItemIsEnabled} hook produces a predicate function for testing
 * that a {@link FeatureFlaggedItem} has a feature flag defined and enabled;
 * when no feature flag is defined, it is treated as implicitly enabled.
 *
 * @see {@link useFlags}
 * @see {@link FeatureFlaggedItem}
 */
export const useItemIsEnabled = <
  T extends FeatureFlaggedItem
>(): FeatureFlaggedItemPredicate<T> => {
  const flags = useFlags();
  return useCallback<FeatureFlaggedItemPredicate<T>>(
    (item: T): boolean => (item.featureFlag ? flags[item.featureFlag] : true),
    [flags]
  );
};
